/* eslint-disable react/prop-types */
import React from 'react';

import { CadastroUsuario } from './descriptions/cadastro_usuario';
import { SubmissaoDados } from './descriptions/submissao_dados';
import { AtualizacaoPerfil } from './descriptions/atualizacao_perfil';
import { ReabrirCompetencia } from './descriptions/reabrir_competencia';
import { AtualizacaoSuporte } from './descriptions/atualizacao_suporte';
import { AdicaoLinhaCuidado } from './descriptions/adicao_linha_cuidado';
import { CadastroInstituicao } from './descriptions/cadastro_instituicao';
import { ExportacaoDados } from './descriptions/exportacao_dados';

export default function RenderDescription({ tipoDeOperacao, modalData }) {
  return (
    <div className="data">
      {tipoDeOperacao === 'SUBMISSAO_DADOS' && (
        <SubmissaoDados modalData={modalData} />
      )}

      {tipoDeOperacao === 'CADASTRO_USUARIO' && (
        <CadastroUsuario modalData={modalData} />
      )}

      {tipoDeOperacao === 'ATUALIZACAO_PERFIL' && (
        <AtualizacaoPerfil modalData={modalData} />
      )}

      {tipoDeOperacao === 'REABIR_COMPETENCIA' && (
        <ReabrirCompetencia modalData={modalData} />
      )}

      {tipoDeOperacao === 'ATUALIZAO_SUPORTE' && (
        <AtualizacaoSuporte modalData={modalData} />
      )}

      {tipoDeOperacao === 'ADICAO_LINHA_CUIDADO' && (
        <AdicaoLinhaCuidado modalData={modalData} />
      )}

      {tipoDeOperacao === 'CADASTRO_INSTITUICAO' && (
        <CadastroInstituicao modalData={modalData} />
      )}

      {tipoDeOperacao === 'EXPORTACAO_DADOS' && (
        <ExportacaoDados modalData={modalData} />
      )}
    </div>
  );
}
